module.exports = __webpack_public_path__ + "static/media/finance.0633275e.svg";